import { Box } from "@mui/material";

export function VideoCard({ src, poster, title }) {
  return (
    <Box
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        aspectRatio: "9 / 16",
        transition: "border-color 0.3s ease, transform 0.3s ease",
        "&:hover": { borderColor: "primary.main", transform: "translateY(-4px)" },
      }}
    >
      {/* preload="none": only the poster loads until the visitor hits play */}
      <video
        src={src}
        poster={poster}
        title={title}
        aria-label={title}
        controls
        playsInline
        preload="none"
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
      />
    </Box>
  );
}
